import { Component, Input, OnInit } from '@angular/core';
import { RekbotNotesService } from '../../../../services/rekbots-notes.service';
import { RekbotNote } from '../../rekbot-layout-models/rekbot-note.model';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../../services/notification.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";
import { MatInputModule } from '@angular/material/input';
import { RekbotNoteStateService } from '../../rekbot-layout-services/rekbot-note-state.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-rekbot-view-note',
  imports: [
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    RouterLink,
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatIcon,
    MatInputModule,
    CdkDragPlaceholder
],
  templateUrl: './rekbot-view-note.component.html',
  styleUrl: './rekbot-view-note.component.css'
})
export class RekbotViewNoteComponent implements OnInit {
  rekbotId!: number;
  noteId!: number;
  isEditing = false;
  changeAttachment = false;
  note: RekbotNote = new RekbotNote('','','');
  isDeleting = false;
  apiUrl = environment.apiUrl;
  attachmentUrl?: SafeResourceUrl;
  selectedFiles?: File[];

  constructor(
    private rekbotNotesService: RekbotNotesService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private rekbotNoteStateService: RekbotNoteStateService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.rekbotId = this.route.parent?.snapshot.params['rekbotId'];
    this.noteId = this.route.snapshot.params['noteId'];
    this.isEditing = this.rekbotNoteStateService.getEditing();

    console.log("Edytowanie ustawione na: ", this.isEditing);
    
    console.log("rekbotId: " + this.rekbotId + " NoteId: " + this.noteId)
    
    this.fetchNote();
  }

  fetchNote() {
    this.rekbotNotesService.getNote(this.rekbotId, this.noteId)
    .subscribe({
      next: note => {
        console.log("Wczytana notatka: ", note);
        if(note.attachment_url){
          this.setFile(note.attachment_url);
        }
        this.note = note
      }
    })
  }
  
  setFile(url: string) {
    this.attachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onDeleteNote() {
    if (confirm("Czy na pewno chcesz usunąć tę notatke?")) {
      this.isDeleting = true;
      this.rekbotNotesService.deleteNote(this.rekbotId, this.noteId)
      .subscribe({
        next: () => {
          this.notificationService.pushNotification("Notatka usunięta", "info", 5000);
          this.router.navigate(['../../'], { relativeTo: this.route });
        },
        error: err => {
          this.notificationService.pushNotification("Błąd podczas usuwania notatki", "error", 5000);
          console.error(err);
          this.isDeleting = false;
        }
      })
    }
  }

  onSaveNote() {
    let body: FormData | RekbotNote;
    if(this.changeAttachment && this.selectedFiles) {
      const formData = new FormData();
      formData.append('title', this.note.title);
      formData.append('note', this.note.note);
      formData.append('note_type',this.note.note_type);
      this.selectedFiles.forEach((file: File) => {
        formData.append('attachment', file, file.name);
      });
      // console.log("Zapisywany form data:", formData);
      // console.log("Załaczniki zapisywane:", this.selectedFiles);
      
      body = formData;
      console.log("Zapisywany form data (body):", body);
    } else {
      console.log("Zapisywana notatka bez attachemnt:", this.note);
      
      body = this.note;
    }
    this.rekbotNotesService.updateNote(this.rekbotId, this.noteId, body)
    .subscribe({
      next: () => {
        this.notificationService.pushNotification("Notatka zaktualizowana", "info", 5000);
        this.fetchNote();
        this.isEditing = false;
      },
      error: err => {
        this.notificationService.pushNotification("Błąd podczas aktualizacji notatki", "error", 5000);
        console.error(err);
      }
    })
  }

  onCancelEdit() {
    this.isEditing = false;
    this.fetchNote();
  }

  onDeleteAttachment() {
    if (confirm("Czy na pewno chcesz usunąć ten załącznik?")) {
      if(this.selectedFiles) {

      } else {
        this.changeAttachment = true;
        this.note.attachment = "";
        this.note.attachment_url = "";
      }
    }
  }

  onFileSelected(event: any) {
    this.changeAttachment = true;
    this.selectedFiles = this.selectedFiles ? [...this.selectedFiles, ...Array.from(event.target.files).filter((file: any) => !this.selectedFiles?.some(f => f.name === file.name))] as File[] : Array.from(event.target.files) as File[];
    console.log("dodany załącznik: ", this.selectedFiles);
    
  }

  onDeleteFile(file: File) {
    this.selectedFiles = this.selectedFiles?.filter(f => f.name !== file.name);
  }
}
